var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "document-container" },
    [
      _c("document-attachments"),
      _vm._v(" "),
      _c(
        "base-modal-duplicate",
        {
          ref: "base-modal",
          attrs: {
            loading: _vm.dtIsRecording,
            disabled: _vm.hasntAttachment,
            "action-position": "center",
            icon: "document_bleu",
            "before-close": _vm.handleBeforeModalClose,
            "submit-btn-title": _vm.buttonText,
            "hide-default-action": true,
            title: _vm.modalTitle,
            "max-width": _vm.maxWidth,
            "is-yellow-title": ""
          },
          on: { onRecord: _vm.handleSave, onClose: _vm.handleClose },
          model: {
            value: _vm.isOpenModal,
            callback: function($$v) {
              _vm.isOpenModal = $$v
            },
            expression: "isOpenModal"
          }
        },
        [_c("document-modal-vertical")],
        1
      ),
      _vm._v(" "),
      _vm.dtErrorModalVisible
        ? _c("base-error-dialog", {
            attrs: { error: _vm.dtError },
            on: { cancel: _vm.handleRemoveError }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17e3ecd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17e3ecd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/block-documents/template.html
// module id = null
// module chunks = 